import './Hero.scss';

class Hero {

	constructor(node) {
		this.node = node;
	}

	init() {
		console.log('Hero');
	}

}

if (typeof JSModules === "object") {
	JSModules['Hero'] = Hero;
} else {
	// initialize section
	let section = new Hero;
	section.init();
}

export default Hero;
